import React from "react";

import "./infobar.scss";
import { useRecoilState, useRecoilValue } from "recoil";
import { authorizedState, loginModalState, registerModalState } from "atoms/atoms";
import { Link, useNavigate } from "react-router-dom";

function InfoBar() {
  const [loginModalStateValue, setloginModalState] = useRecoilState(loginModalState);
  const [registerModalIsVisible, setRegisterModalIsVisible] = useRecoilState(registerModalState);
  const authorized = useRecoilValue(authorizedState);
  const navigate = useNavigate();

  const toggleLoginModal = () => {
    if (loginModalStateValue.isVisible) {
      setTimeout(() => {
        setloginModalState({ isVisible: false, redirectAfterLogin: null });
      }, 300);
    } else {
      setloginModalState({ isVisible: true, redirectAfterLogin: null });
      setRegisterModalIsVisible(false);
    }
  };

  const toggleRegisterModal = () => {
    if (registerModalIsVisible) {
      setTimeout(() => {
        setRegisterModalIsVisible(false);
      }, 300);
    } else {
      setRegisterModalIsVisible(true);
      setloginModalState({ isVisible: false, redirectAfterLogin: null });
    }
  };

  return (
    <div className="infobar">
      <div className="container">
        <ul className="infobar-links">
          <li>
            <a href="https://honvedfc.hu">honvedfc.hu</a>
          </li>
          <li>
            <Link to="/tartalom/szallitas">Szállítás</Link>
          </li>
          <li>
            <Link to="/tartalom/merettablazat">Mérettáblázat</Link>
          </li>
        </ul>

        <ul className="infobar-authentication">
          {authorized && (
            <li>
              <button onClick={() => navigate("/profil")}>Profil</button>
            </li>
          )}
          {!authorized && (
            <li>
              <button onClick={toggleLoginModal}>Belépés</button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default InfoBar;
